// import React, { useState, useEffect } from 'react';
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
// import { BASE_URL } from '../../utils';

function PrivateRoute({ children, ...rest }) {
  const isSignedIn = JSON.parse(localStorage.getItem('isSignedIn')) || false;
  // const [isSignedIn, setIsSignedIn] = useState(false);
  // useEffect(async () => {
  //   const reqHeaders = new Headers();
  //   const token = localStorage.getItem('token');
  //   reqHeaders.append('Authorization', `Bearer ${token}`);
  //   const requestOptions = {
  //     method: 'POST',
  //     redirect: 'follow',
  //     headers: reqHeaders
  //   };
  //   const res = await fetch(`${BASE_URL}/users/isSignedIn`, requestOptions);
  //   const json = await res.json();
  //   if (json.success) {
  //     setIsSignedIn(true);
  //   } else {
  //     setIsSignedIn(false);
  //   }
  // }, []);

  return (
    <Route
      {...rest}
      render={({ location }) =>
        isSignedIn
          ? (children)
          : (<Redirect
                to={{
                  pathname: '/',
                  state: { from: location, showSignInDialog: true }
                }}
              />
            )
      }
    />
  );
}

export default PrivateRoute;
